var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-container',[_vm._v("测试页")])
}
var staticRenderFns = []

export { render, staticRenderFns }